export default __webpack_public_path__ + "static/media/bitcoin-btc-logo.82491fef.png";